import { app } from "@/main";
import { useAuthStore } from "@/store/auth";
import { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";
import { Exceptions, Messages } from "./messages.util";
import { ToastFactory } from "./toast-factory.util";

interface OriginalRequestAxios extends AxiosRequestConfig {
  _retry?: boolean;
}

export default class HandleError {
  async getErrors(error: AxiosError, instance: AxiosInstance) {
    const errResponse = (error.response as any)?.data;
    switch (error.response?.status) {
      case 400:
        this.renderToastError(errResponse);
        break;
      case 401:
        return await this.refreshTokenWithError(error, instance);
      case 415:
        this.renderToastError("ERR_MEDIA_TYPE");
        break;
      default:
        return Promise.reject(error);
    }

    return Promise.reject(error);
  }

  renderToastError(error: any): void {
    if (!error.restErrors) {
      if (error.code !== String(Exceptions[error.code])) {
        app.config.globalProperties.$toast.add(
          ToastFactory.error(this.getMessage(error.code ?? error))
        );
      }
    } else {
      if (error.code !== String(Exceptions[error.code])) {
        error?.restErrors?.forEach((err) => {
          app.config.globalProperties.$toast.add(
            ToastFactory.error(this.getMessage(err?.field))
          );
        });
      }
    }
  }

  async refreshTokenWithError(
    error: AxiosError,
    instance: AxiosInstance | any
  ): Promise<AxiosError | void> {
    const originalRequest = error.config as OriginalRequestAxios;

    if (originalRequest.url?.includes("/refresh-token")) {
      useAuthStore.logout();
      return Promise.reject(error);
    }

    if (!originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newToken = await useAuthStore.refreshAccessToken();
        originalRequest.headers!.Authorization = `Bearer ${newToken}`;
        return instance(originalRequest);
      } catch (refreshError) {
        useAuthStore.logout();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }

  getMessage(code: string): string {
    return Messages[code] ?? Messages.GENERIC_ERROR;
  }
}
